/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * A variant can still be bought at zero stock when inventory is tracked and
 * the policy is "continue". That is a pre-order, not a normal Add to Bag.
 */
function swlVariantIsPreorder(variant, scope) {
  if (!variant || !variant.available) {
    return false;
  }

  if (variant.inventory_management && variant.inventory_policy === 'continue' && Number(variant.inventory_quantity) <= 0) {
    return true;
  }

  var root = scope || document;
  var node = root.querySelector('[data-product-json]');

  if (!node) {
    return false;
  }

  try {
    var data = JSON.parse(node.textContent);
    var ids = data.preorder_variant_ids || [];

    for (var i = 0; i < ids.length; i += 1) {
      if (String(ids[i]) === String(variant.id)) {
        return true;
      }
    }
  } catch (error) {
    return false;
  }

  return false;
}

function swlPreorderLabel() {
  return (window.languages && window.languages.productFormPreOrder) || 'Pre-Order';
}

function swlApplyPreorderButton(button) {
  if (!button || button.hasAttribute('disabled')) {
    return;
  }

  var label = swlPreorderLabel();
  var span = button.querySelector('span');

  if (span) {
    span.textContent = label;
    return;
  }

  button.textContent = label;
}

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail && event.detail.variant;

  if (!variant || !variant.available) {
    return;
  }

  var productRoot = event.target && event.target.closest ? event.target.closest('[data-section-type="product"], .Product') : null;
  var scope = productRoot || document;
  var isPreorder = swlVariantIsPreorder(variant, scope);
  var stickyButton = document.querySelector('.ProductForm__AddToCart--sticky');

  if (isPreorder) {
    var buttons = scope.querySelectorAll('.ProductForm__AddToCart');

    for (var i = 0; i < buttons.length; i += 1) {
      swlApplyPreorderButton(buttons[i]);
    }

    swlApplyPreorderButton(stickyButton);

    var paymentButton = scope.querySelector('.shopify-payment-button');

    if (paymentButton) {
      paymentButton.style.display = 'none';
    }

    return;
  }

  if (!stickyButton || stickyButton.hasAttribute('disabled')) {
    return;
  }

  var availableLabel = (window.languages && window.languages.productFormAddToCart) || 'Add to Bag';
  var stickySpan = stickyButton.querySelector('span');

  if (stickySpan) {
    stickySpan.textContent = availableLabel;
    return;
  }

  stickyButton.textContent = availableLabel;
});

/**
 * Custom size dropdown. Native select menus use OS chrome; this keeps the
 * list on the page, same width as Add to Bag. Hidden radios still drive Prestige.
 */
(function () {
  const rootSelector = '[data-size-select]';

  const closeSelect = (root) => {
    const trigger = root.querySelector('.ProductForm__SizeSelectTrigger');
    const list = root.querySelector('.ProductForm__SizeSelectList');

    if (!trigger || !list) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    list.hidden = true;
    root.classList.remove('is-open');
  };

  const openSelect = (root) => {
    const trigger = root.querySelector('.ProductForm__SizeSelectTrigger');
    const list = root.querySelector('.ProductForm__SizeSelectList');

    if (!trigger || !list) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'true');
    list.hidden = false;
    root.classList.add('is-open');
  };

  const closeAll = (except) => {
    for (const root of document.querySelectorAll(rootSelector + '.is-open')) {
      if (root !== except) {
        closeSelect(root);
      }
    }
  };

  const chooseValue = (root, button) => {
    const value = button.getAttribute('data-value');
    const label = (button.getAttribute('data-label') || button.textContent).replace(/\s+/g, ' ').trim();
    const triggerValue = root.querySelector('.ProductForm__SizeSelectValue');
    const optionRoot = root.closest('.ProductForm__Option');

    if (triggerValue) {
      triggerValue.textContent = label;
    }

    for (const option of root.querySelectorAll('.ProductForm__SizeSelectOption')) {
      const selected = option === button;
      const status = option.querySelector('.ProductForm__SizeSelectStatus');
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');

      if (status) {
        status.hidden = !selected;
      }
    }

    if (optionRoot && value) {
      const radios = optionRoot.querySelectorAll('.SizeSwatch__Radio');
      let radio = null;

      for (const candidate of radios) {
        if (candidate.value === value) {
          radio = candidate;
          break;
        }
      }

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    closeSelect(root);
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest('.ProductForm__SizeSelectOption');

    if (option) {
      event.preventDefault();
      chooseValue(option.closest(rootSelector), option);
      return;
    }

    const trigger = event.target.closest('.ProductForm__SizeSelectTrigger');

    if (trigger && !trigger.classList.contains('ProductForm__SizeSelectTrigger--static')) {
      event.preventDefault();
      const root = trigger.closest(rootSelector);
      const isOpen = root.classList.contains('is-open');

      closeAll();

      if (!isOpen) {
        openSelect(root);
      }

      return;
    }

    closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    const openRoot = document.querySelector(rootSelector + '.is-open');

    if (!openRoot) {
      return;
    }

    closeSelect(openRoot);
    const trigger = openRoot.querySelector('.ProductForm__SizeSelectTrigger');

    if (trigger) {
      trigger.focus();
    }
  });
})();

/**
 * Initialize filter popover on mobile (bottom sheet style, matching sort behavior)
 */
(function() {
  'use strict';

  var filterPopoverInstance = null;

  // Check if we're on mobile (using the same breakpoint as the theme)
  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function initFilterPopover() {
    var filterPopoverElement = document.getElementById('collection-filter-popover');
    var filterButton = document.querySelector('[data-filter-button]');
    
    if (!filterPopoverElement) {
      console.log('Filter popover: Element not found');
      return;
    }
    
    if (!filterButton) {
      console.log('Filter popover: Button not found');
      return;
    }
    
    console.log('Filter popover: Initialized', { element: filterPopoverElement, button: filterButton, isMobile: isMobile() });

    // Remove drawer attributes on mobile to prevent drawer from opening
    if (isMobile()) {
      filterButton.removeAttribute('data-action');
      filterButton.removeAttribute('data-drawer-id');
    }

    // Function to hide the Filters button
    function hideFiltersButton() {
      // Find the collapsible that contains the Linklist (filter options)
      var valueList = filterPopoverElement.querySelector('.Popover__ValueList');
      if (!valueList) return;
      
      // Find all collapsibles
      var collapsibles = valueList.querySelectorAll('.Collapsible');
      
      collapsibles.forEach(function(collapsible) {
        var linklist = collapsible.querySelector('.Linklist');
        if (linklist) {
          // This is the Filters wrapper - hide its button
          collapsible.setAttribute('data-hide-button', 'true');
          
          var button = collapsible.querySelector('.Collapsible__Button');
          if (button) {
            // Completely hide and disable
            button.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; padding: 0 !important; margin: 0 !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; left: -9999px !important; width: 0 !important;';
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
            button.setAttribute('disabled', 'true');
            
            // Remove all event listeners by replacing with a disabled button
            var parent = button.parentNode;
            var newButton = document.createElement('button');
            newButton.className = button.className;
            newButton.style.cssText = button.style.cssText;
            newButton.setAttribute('aria-hidden', 'true');
            newButton.setAttribute('tabindex', '-1');
            newButton.setAttribute('disabled', 'true');
            newButton.setAttribute('type', 'button');
            parent.replaceChild(newButton, button);
            
            // Expand the inner content
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.cssText = 'height: auto !important; visibility: visible !important; overflow: visible !important; display: block !important; max-height: none !important; margin-top: 0 !important; padding-top: 0 !important;';
              inner.setAttribute('aria-hidden', 'false');
            }
            
            collapsible.setAttribute('data-force-expanded', 'true');
          }
        }
      });
    }

    // Simple popover implementation for mobile
    function openPopover() {
      if (!isMobile()) return;
      filterPopoverElement.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      var pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.add('is-visible');
        pageOverlay.addEventListener('click', closePopover);
      }
      filterButton.setAttribute('aria-expanded', 'true');
      
      // Hide the "Filters" button immediately
      hideFiltersButton();
      
      // Hide the "Filters" button (with plus icon) but keep the filter options visible
      // Auto-expand all collapsible sections in the filter popover
      setTimeout(function() {
        hideFiltersButton(); // Run again to be sure
        // Find all collapsibles in the popover
        var collapsibles = filterPopoverElement.querySelectorAll('.Popover__ValueList .Collapsible');
        
        collapsibles.forEach(function(collapsible) {
          var button = collapsible.querySelector('.Collapsible__Button');
          if (!button) return;
          
          // Check if this collapsible contains a Linklist (filter options)
          var hasLinklist = collapsible.querySelector('.Linklist');
          
          // Get button text
          var buttonText = button.textContent.trim();
          var plusIcon = button.querySelector('.Collapsible__Plus');
          if (plusIcon) {
            buttonText = buttonText.replace(plusIcon.textContent || '', '').trim();
          }
          
          // This is the "Filters" wrapper button if it has Linklist inside
          if (hasLinklist && (buttonText === 'Filters' || buttonText.toLowerCase().includes('filter'))) {
            // Completely remove the button from DOM or hide it thoroughly
            button.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; padding: 0 !important; margin: 0 !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; left: -9999px !important;';
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
            
            // Remove all event listeners by cloning
            var newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            button = newButton;
            
            // Prevent any clicks
            button.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }, true);
            
            // Make sure the inner content is always visible and expanded
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.cssText = 'height: auto !important; visibility: visible !important; overflow: visible !important; display: block !important; max-height: none !important; margin-top: 0 !important; padding-top: 0 !important;';
              inner.setAttribute('aria-hidden', 'false');
              
              var content = inner.querySelector('.Collapsible__Content');
              if (content) {
                content.style.display = 'block';
              }
            }
            
            // Set attributes
            collapsible.setAttribute('data-force-expanded', 'true');
            button.setAttribute('aria-expanded', 'true');
          } else {
            // For other collapsibles (like quick links, groups), just expand them
            button.setAttribute('aria-expanded', 'true');
            
            var inner = collapsible.querySelector('.Collapsible__Inner');
            if (inner) {
              inner.style.height = 'auto';
              inner.style.visibility = 'visible';
              inner.style.overflow = 'visible';
            }
          }
        });
      }, 100);
    }

    function closePopover() {
      filterPopoverElement.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      var pageOverlay = document.querySelector('.PageOverlay');
      if (pageOverlay) {
        pageOverlay.classList.remove('is-visible');
        pageOverlay.removeEventListener('click', closePopover);
      }
      filterButton.setAttribute('aria-expanded', 'false');
    }

    function togglePopover() {
      var isOpen = filterPopoverElement.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closePopover();
      } else {
        openPopover();
      }
    }

    // Override the filter button click to open popover on mobile instead of drawer
    // Use capture phase to intercept before drawer handler
    filterButton.addEventListener('click', function(e) {
      if (isMobile()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        togglePopover();
        return false;
      }
      // On desktop, let the default drawer behavior work
    }, true); // Use capture phase

    // Handle close button in popover
    var closeButton = filterPopoverElement.querySelector('[data-action="close-popover"]');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePopover();
      });
    }

    // Handle apply tags button in popover
    filterPopoverElement.addEventListener('click', function(e) {
      if (e.target.closest('[data-action="apply-tags"]')) {
        // Let the default handler work, then close popover
        setTimeout(function() {
          closePopover();
        }, 100);
      }
    });

    // Close on overlay click
    var pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) {
      var overlayClickHandler = function() {
        if (isMobile() && filterPopoverElement.getAttribute('aria-hidden') === 'false') {
          closePopover();
        }
      };
      pageOverlay.addEventListener('click', overlayClickHandler);
    }

    filterPopoverInstance = {
      open: openPopover,
      close: closePopover,
      toggle: togglePopover
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterPopover);
  } else {
    initFilterPopover();
  }

  // Re-initialize on section load (for AJAX navigation)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initFilterPopover, 100);
  });

  // Fix button text disappearing after filter/sort is applied
  function ensureFilterButtonText() {
    var filterButtons = document.querySelectorAll('[data-filter-button]');
    filterButtons.forEach(function(filterButton) {
      var span = filterButton.querySelector('span');
      if (!span || span.textContent.trim() === '' || span.textContent.trim().length < 3) {
        // Restore the text if it's missing or too short
        var icon = filterButton.querySelector('svg');
        var tagCount = 0;
        try {
          var tagCountElement = span ? span.querySelector('.Text--subdued') : null;
          if (tagCountElement) {
            var match = tagCountElement.textContent.match(/\((\d+)\)/);
            if (match) tagCount = parseInt(match[1], 10);
          }
        } catch(e) {}
        
        var filterText = 'Filter';
        if (tagCount > 0) {
          filterText += ' <span class="Text--subdued">(' + tagCount + ')</span>';
        }
        
        if (span) {
          span.innerHTML = filterText;
        } else {
          var newSpan = document.createElement('span');
          newSpan.innerHTML = filterText;
          if (icon && icon.nextSibling) {
            filterButton.insertBefore(newSpan, icon.nextSibling);
          } else if (icon) {
            filterButton.appendChild(newSpan);
          }
        }
      }
    });
  }

  // Run after page loads and after AJAX updates
  function runButtonTextFix() {
    setTimeout(ensureFilterButtonText, 100);
    setTimeout(ensureFilterButtonText, 500);
    setTimeout(ensureFilterButtonText, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runButtonTextFix);
  } else {
    runButtonTextFix();
  }

  // Also run after collection updates (when filters/sort are applied)
  document.addEventListener('shopify:section:load', runButtonTextFix);
  
  // Listen for collection reload events
  document.addEventListener('theme:loading:end', runButtonTextFix);

  // Also intercept at document level to catch it before drawer handler
  document.addEventListener('click', function(e) {
    var filterButton = e.target.closest('[data-filter-button]');
    if (filterButton && isMobile()) {
      var filterPopoverElement = document.getElementById('collection-filter-popover');
      if (filterPopoverElement) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var isOpen = filterPopoverElement.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          filterPopoverElement.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('no-scroll');
          var pageOverlay = document.querySelector('.PageOverlay');
          if (pageOverlay) {
            pageOverlay.classList.remove('is-visible');
          }
          filterButton.setAttribute('aria-expanded', 'false');
        } else {
          filterPopoverElement.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('no-scroll');
          var pageOverlay = document.querySelector('.PageOverlay');
          if (pageOverlay) {
            pageOverlay.classList.add('is-visible');
          }
          filterButton.setAttribute('aria-expanded', 'true');
        }
        return false;
      }
    }
  }, true); // Use capture phase to intercept early
})();

/**
 * Progressive disclosure for product gallery thumbnails
 * Shows 3-4 thumbnails at a time with up/down arrow navigation
 */
(function() {
  'use strict';

  function initThumbnailProgressiveDisclosure() {
    var thumbnailNav = document.querySelector('.Product__SlideshowNav--thumbnails');
    if (!thumbnailNav) return;

    var scroller = thumbnailNav.querySelector('.Product__SlideshowNavScroller');
    if (!scroller) return;

    var upArrow = thumbnailNav.querySelector('.Product__ThumbnailNavArrow--up');
    var downArrow = thumbnailNav.querySelector('.Product__ThumbnailNavArrow--down');
    var thumbnails = Array.from(thumbnailNav.querySelectorAll('.Product__SlideshowNavImage'));

    if (thumbnails.length <= 4) {
      // Not enough thumbnails to need scrolling - hide arrows
      if (upArrow) upArrow.style.display = 'none';
      if (downArrow) downArrow.style.display = 'none';
      return;
    }
    
    // Ensure arrows are displayable (they start hidden via CSS)
    if (upArrow) upArrow.style.display = 'flex';
    if (downArrow) downArrow.style.display = 'flex';

    // Calculate thumbnail height including margin
    function getThumbnailHeight() {
      if (thumbnails.length === 0) return 0;
      var firstThumb = thumbnails[0];
      var rect = firstThumb.getBoundingClientRect();
      var style = window.getComputedStyle(firstThumb);
      var marginBottom = parseInt(style.marginBottom, 10) || 0;
      return rect.height + marginBottom;
    }

    // Update arrow state - keep visible but disable when at limits
    function updateArrowVisibility() {
      var scrollTop = scroller.scrollTop;
      var scrollHeight = scroller.scrollHeight;
      var clientHeight = scroller.clientHeight;
      var isAtTop = scrollTop <= 5; // Small threshold for rounding
      var isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;

      if (upArrow) {
        if (isAtTop) {
          upArrow.classList.add('is-disabled');
        } else {
          upArrow.classList.remove('is-disabled');
        }
      }

      if (downArrow) {
        if (isAtBottom) {
          downArrow.classList.add('is-disabled');
        } else {
          downArrow.classList.remove('is-disabled');
        }
      }
    }

    // Scroll by one thumbnail
    function scrollThumbnails(direction) {
      var thumbnailHeight = getThumbnailHeight();
      var currentScroll = scroller.scrollTop;
      var scrollAmount = thumbnailHeight;

      if (direction === 'up') {
        scroller.scrollTo({
          top: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else if (direction === 'down') {
        scroller.scrollTo({
          top: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }
    }

    // Smooth scroll helper with easing (for luxury feel)
    var isScrolling = false;
    var scrollTimeout = null;
    
    function smoothScrollTo(scroller, targetPosition, duration) {
      if (isScrolling) return; // Prevent overlapping scrolls
      
      duration = duration || 400; // 400ms for smooth, polished feel
      var startPosition = scroller.scrollTop;
      var distance = targetPosition - startPosition;
      var startTime = null;
      
      // If distance is very small, skip animation
      if (Math.abs(distance) < 2) {
        scroller.scrollTop = targetPosition;
        return;
      }
      
      isScrolling = true;
      
      function easeInOutCubic(t) {
        // Smooth easing function for luxury feel
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
      
      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var timeElapsed = currentTime - startTime;
        var progress = Math.min(timeElapsed / duration, 1);
        var easedProgress = easeInOutCubic(progress);
        
        scroller.scrollTop = startPosition + (distance * easedProgress);
        
        if (progress < 1) {
          requestAnimationFrame(animation);
        } else {
          isScrolling = false;
        }
      }
      
      requestAnimationFrame(animation);
    }
    
    // Scroll to specific thumbnail - centers it in viewport (luxury e-commerce best practice)
    function scrollToThumbnail(thumbnail, center) {
      if (!thumbnail) return;
      
      // Debounce rapid calls
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(function() {
        center = center !== false; // Default to true (center), unless explicitly false
        
        var scrollerRect = scroller.getBoundingClientRect();
        var thumbnailRect = thumbnail.getBoundingClientRect();
        
        // Check if thumbnail is partially or completely outside visible area
        var isPartiallyVisible = (
          thumbnailRect.top < scrollerRect.bottom &&
          thumbnailRect.bottom > scrollerRect.top
        );
        
        var isCompletelyVisible = (
          thumbnailRect.top >= scrollerRect.top &&
          thumbnailRect.bottom <= scrollerRect.bottom
        );
        
        // If thumbnail is completely visible and centered, no need to scroll
        if (isCompletelyVisible && center) {
          var thumbnailCenter = thumbnailRect.top + (thumbnailRect.height / 2);
          var scrollerCenter = scrollerRect.top + (scrollerRect.height / 2);
          var centerOffset = Math.abs(thumbnailCenter - scrollerCenter);
          
          // If already centered (within 8px tolerance for smoother feel), don't scroll
          if (centerOffset < 8) {
            return;
          }
        }
        
        // If thumbnail is partially or completely outside visible area, scroll to it
        if (!isPartiallyVisible || (center && !isCompletelyVisible)) {
          if (center) {
            // Center the thumbnail in the viewport with smooth animation
            var thumbnailOffset = thumbnail.offsetTop - scroller.offsetTop;
            var thumbnailHeight = thumbnailRect.height;
            var scrollerHeight = scrollerRect.height;
            var scrollPosition = thumbnailOffset - (scrollerHeight / 2) + (thumbnailHeight / 2);
            
            smoothScrollTo(scroller, Math.max(0, scrollPosition), 400);
          } else {
            // Just bring into view (original behavior)
            var thumbnailHeight = getThumbnailHeight();
            var thumbnailIndex = thumbnails.indexOf(thumbnail);
            var scrollPosition = thumbnailIndex * thumbnailHeight;
            
            smoothScrollTo(scroller, scrollPosition, 400);
          }
        }
      }, 50); // Small debounce to prevent jerky rapid scrolling
    }
    
    // Auto-scroll to selected thumbnail when main image changes (luxury e-commerce best practice)
    var autoScrollTimeout = null;
    function autoScrollToSelectedThumbnail() {
      // Debounce to prevent rapid-fire scrolling
      if (autoScrollTimeout) {
        clearTimeout(autoScrollTimeout);
      }
      
      autoScrollTimeout = setTimeout(function() {
        // Find the currently selected thumbnail
        var selectedThumbnail = thumbnails.find(function(thumb) {
          return thumb.classList.contains('is-selected');
        });
        
        if (selectedThumbnail && !isScrolling) {
          // Smoothly scroll to center the selected thumbnail
          scrollToThumbnail(selectedThumbnail, true);
        }
      }, 100); // Small delay to batch rapid changes
    }
    
    // Watch for changes to selected thumbnail (mutations or scroll events)
    function watchForImageChanges() {
      var isCarouselGallery = document.querySelector('.Product--stickyGallery');

      // Carousel / sticky gallery: theme.js already syncs the selected thumbnail
      if (isCarouselGallery) {
        var carouselNav = document.querySelector('.Product__SlideshowNav--thumbnails');

        if (!carouselNav) {
          return;
        }

        var mutationObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var target = mutation.target;

              if (target.classList.contains('is-selected') && thumbnails.includes(target)) {
                autoScrollToSelectedThumbnail();
              }
            }
          });
        });

        mutationObserver.observe(carouselNav, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });

        return;
      }

      // For stack mode: Use Intersection Observer to detect when main images come into view
      var mainImages = document.querySelectorAll('.Product__SlideItem[data-media-id]');
      
      if (mainImages.length === 0) return;
      
      var visibleImages = new Map(); // Track intersection ratios for all visible images
      
      // Create Intersection Observer to detect when main images become visible
      var imageObserver = new IntersectionObserver(function(entries) {
        // Update visible images map
        entries.forEach(function(entry) {
          var mediaId = entry.target.getAttribute('data-media-id');
          
          if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
            // Image is at least 10% visible
            visibleImages.set(mediaId, entry.intersectionRatio);
          } else {
            visibleImages.delete(mediaId);
          }
        });
        
        // Find the most visible image (highest intersection ratio)
        if (visibleImages.size > 0) {
          var mostVisibleMediaId = null;
          var maxRatio = 0;
          
          visibleImages.forEach(function(ratio, mediaId) {
            if (ratio > maxRatio) {
              maxRatio = ratio;
              mostVisibleMediaId = mediaId;
            }
          });
          
          // Only update if we have a clear winner (at least 30% visible)
          if (mostVisibleMediaId && maxRatio >= 0.3) {
            // Find corresponding thumbnail
            var correspondingThumbnail = thumbnails.find(function(thumb) {
              return thumb.getAttribute('data-media-id') === mostVisibleMediaId;
            });
            
            if (correspondingThumbnail) {
              var wasAlreadySelected = correspondingThumbnail.classList.contains('is-selected');
              
              // Remove selection from all thumbnails
              thumbnails.forEach(function(thumb) {
                thumb.classList.remove('is-selected');
              });
              
              // Add selection to corresponding thumbnail
              correspondingThumbnail.classList.add('is-selected');
              
              // Auto-scroll to center the selected thumbnail (only if it wasn't already selected)
              if (!wasAlreadySelected) {
                autoScrollToSelectedThumbnail();
              }
            }
          }
        }
      }, {
        threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0], // Multiple thresholds for accurate tracking
        rootMargin: '-10% 0px -10% 0px' // Consider viewport with small margin
      });
      
      // Observe all main product images
      mainImages.forEach(function(image) {
        imageObserver.observe(image);
      });
      
      // Also watch for programmatic selection changes (DOM mutations) - for click events
      var thumbnailNav = document.querySelector('.Product__SlideshowNav--thumbnails');
      if (thumbnailNav) {
        var mutationObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var target = mutation.target;
              // Check if any thumbnail was just selected
              if (target.classList.contains('is-selected') && thumbnails.includes(target)) {
                // Thumbnail was just selected (likely via click) - auto-scroll to center it
                autoScrollToSelectedThumbnail();
              }
            }
          });
        });
        
        mutationObserver.observe(thumbnailNav, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }
    }

    // Handle arrow clicks - only scroll if not disabled
    if (upArrow) {
      upArrow.addEventListener('click', function(e) {
        if (!upArrow.classList.contains('is-disabled')) {
          e.preventDefault();
          scrollThumbnails('up');
        }
      });
    }

    if (downArrow) {
      downArrow.addEventListener('click', function(e) {
        if (!downArrow.classList.contains('is-disabled')) {
          e.preventDefault();
          scrollThumbnails('down');
        }
      });
    }

    // Handle thumbnail clicks - auto-scroll if needed (center it)
    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function(e) {
        // Small delay to let the default click handler run first
        setTimeout(function() {
          scrollToThumbnail(thumbnail, true); // Center the clicked thumbnail
        }, 100);
      });
    });

    // Update arrow visibility on scroll
    scroller.addEventListener('scroll', function() {
      updateArrowVisibility();
    });

    // Initial arrow visibility check
    updateArrowVisibility();

    // Update on window resize (in case thumbnail size changes)
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updateArrowVisibility();
        // Re-center selected thumbnail after resize
        autoScrollToSelectedThumbnail();
      }, 250);
    });
    
    // Initialize auto-scroll watcher for selected thumbnails
    watchForImageChanges();
    
    // Initial check: auto-scroll to selected thumbnail on load
    setTimeout(function() {
      autoScrollToSelectedThumbnail();
    }, 500); // Small delay to ensure DOM is fully ready
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initThumbnailProgressiveDisclosure, 500);
    });
  } else {
    setTimeout(initThumbnailProgressiveDisclosure, 500);
  }

  // Re-initialize on section load (for AJAX navigation)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initThumbnailProgressiveDisclosure, 500);
  });
})();

/**
 * Product gallery: load carousel images that lazysizes skips (loadHidden: false
 * + Flickity overflow), and drive overlay arrows from the live Flickity instance.
 */
(function() {
  'use strict';

  function getSlideshow() {
    return document.querySelector('.Product__Slideshow.Carousel');
  }

  function getFlickity(slideshow) {
    if (!slideshow) {
      return null;
    }

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      return window.Flickity.data(slideshow);
    }

    return slideshow.Flickity || slideshow.flickity || slideshow.flkty || null;
  }

  function unveilSlideshowImages(root) {
    var slideshow = root || getSlideshow();

    if (!slideshow || !window.lazySizes || !window.lazySizes.loader) {
      return;
    }

    var images = slideshow.querySelectorAll('img.Image--lazyLoad, img.Image--lazyLoading');

    for (var i = 0; i < images.length; i++) {
      window.lazySizes.loader.unveil(images[i]);
    }
  }

  function prepareSlideChange(slideshow) {
    if (!slideshow) {
      return;
    }

    var slides = slideshow.querySelectorAll('.Product__SlideItem');

    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.remove('Product__SlideItem--hidden');
    }

    unveilSlideshowImages(slideshow);
  }

  function bindFlickitySelect(slideshow) {
    var flickity = getFlickity(slideshow);

    if (!slideshow || !flickity || slideshow.hasAttribute('data-swl-gallery-bound')) {
      return !!flickity;
    }

    slideshow.setAttribute('data-swl-gallery-bound', '');
    flickity.on('select', function() {
      if (flickity.selectedElement) {
        flickity.selectedElement.classList.remove('Product__SlideItem--hidden');
      }

      unveilSlideshowImages(slideshow);
    });

    return true;
  }

  function initGallery() {
    var slideshow = getSlideshow();

    unveilSlideshowImages(slideshow);
    bindFlickitySelect(slideshow);
  }

  function getCurrentVariant() {
    var jsonEl = document.querySelector('[data-product-json]');

    if (!jsonEl) {
      return null;
    }

    try {
      var data = JSON.parse(jsonEl.textContent);
      var variants = (data.product && data.product.variants) || [];
      var select = document.querySelector('[id^="product-select-"]');
      var selectedOption = select && (select.querySelector('option[selected]') || select.options[select.selectedIndex]);
      var selectedId = selectedOption ? parseInt(selectedOption.value, 10) : data.selected_variant_id;

      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) {
          return variants[i];
        }
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function goToVariantFeaturedMedia() {
    var variant = getCurrentVariant();
    var mediaId = variant && variant.featured_media && String(variant.featured_media.id);

    if (!mediaId) {
      return;
    }

    var section = document.querySelector('[data-section-type="product"]');

    if (!section) {
      return;
    }

    var slide = section.querySelector('.Product__SlideItem[data-media-id="' + mediaId + '"]');

    if (!slide || slide.classList.contains('is-selected')) {
      return;
    }

    if (window.matchMedia('(min-width: 1008px)').matches && section.querySelector('.Product__Gallery--stack')) {
      document.dispatchEvent(new CustomEvent('swl:scroll-to-media', {
        detail: {
          mediaId: mediaId,
          leaveHeader: true
        }
      }));
      return;
    }

    var slideshow = section.querySelector('.Product__Slideshow.Carousel') || getSlideshow();
    var flickity = getFlickity(slideshow);

    if (flickity) {
      prepareSlideChange(slideshow);
      flickity.select(parseInt(slide.getAttribute('data-media-position'), 10) - 1);
      return;
    }

    var navLink = section.querySelector('.Product__SlideshowNavImage[data-media-id="' + mediaId + '"]');

    if (navLink) {
      navLink.click();
    }
  }

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest && event.target.closest('.Product__Info .ColorSwatch, .Product__Info .ColorSwatch__Radio');

    if (!swatch) {
      return;
    }

    var radio = swatch.classList.contains('ColorSwatch__Radio')
      ? swatch
      : document.getElementById(swatch.getAttribute('for'));

    if (!radio || !radio.checked) {
      return;
    }

    goToVariantFeaturedMedia();
  });

  document.addEventListener('click', function(event) {
    var arrow = event.target.closest && event.target.closest('.Product__SlideshowOverlayArrow');

    if (!arrow) {
      return;
    }

    var gallery = arrow.closest('.Product__Gallery');
    var slideshow = gallery ? gallery.querySelector('.Product__Slideshow.Carousel') : getSlideshow();
    var flickity = getFlickity(slideshow);

    if (!flickity) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    prepareSlideChange(slideshow);

    if (arrow.classList.contains('Product__SlideshowOverlayArrow--previous')) {
      flickity.previous();
    } else {
      flickity.next();
    }
  }, true);

  function start() {
    initGallery();
    window.setTimeout(initGallery, 400);
    window.setTimeout(initGallery, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', function() {
    window.setTimeout(initGallery, 100);
  });

  document.addEventListener('shopify:section:load', function() {
    window.setTimeout(initGallery, 200);
  });
})();

/**
 * Keep Klarna out of the sticky Add to Bag row, and always above
 * Complimentary UK Delivery. OSM injects next to ATC when the variant
 * is in stock, but after the form (below reassurance) when sold out.
 */
(function() {
  'use strict';

  var klarnaSelector = 'klarna-placement, .klarna-placement, .klarna-onsite-messaging, [data-key*="credit-promotion"]';

  function isFormChrome(node) {
    if (!node || !node.classList) {
      return false;
    }

    return node.classList.contains('ProductForm__Variants')
      || node.classList.contains('ProductForm__Inventory')
      || node.classList.contains('ProductForm__PurchaseActions')
      || node.classList.contains('ProductForm__Klarna')
      || node.classList.contains('ProductForm__Reassurance')
      || node.classList.contains('shopify-payment-button');
  }

  function relocateKlarna() {
    var form = document.querySelector('.ProductForm');
    var slot = document.querySelector('.ProductForm__Klarna');
    var actions = document.querySelector('.ProductForm__PurchaseActions');

    if (!form || !slot) {
      return;
    }

    var buy = form.closest('.Product__Buy') || form;
    var placements = buy.querySelectorAll(klarnaSelector);

    for (var i = 0; i < placements.length; i++) {
      var node = placements[i];

      if (slot.contains(node)) {
        continue;
      }

      var root = node;
      var limit = form;

      if (actions && actions.contains(node)) {
        limit = actions;
      } else if (!form.contains(node)) {
        limit = buy;
      }

      while (root.parentElement && root.parentElement !== limit && root.parentElement !== slot) {
        root = root.parentElement;
      }

      if (root === slot || slot.contains(root) || isFormChrome(root) || root === form || root === buy) {
        slot.appendChild(node);
        continue;
      }

      slot.appendChild(root);
    }
  }

  function initKlarnaSlot() {
    relocateKlarna();

    var form = document.querySelector('.ProductForm');
    var buy = form && form.closest('.Product__Buy');
    var target = buy || form;

    if (!target) {
      return;
    }

    var observer = new MutationObserver(relocateKlarna);
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlarnaSlot);
  } else {
    initKlarnaSlot();
  }

  document.addEventListener('shopify:section:load', function() {
    window.setTimeout(initKlarnaSlot, 200);
  });
})();

/**
 * Sticky Add to Cart button on mobile
 * Creates a duplicate button that appears when the real button scrolls out of view
 */
(function() {
  'use strict';

  function initStickyAddToCart() {
    // Declare variables at the top of function scope
    var realButton = null;
    var stickyButton = null;
    var isStickyVisible = false;
    
    // Only on mobile
    if (window.matchMedia('(min-width: 641px)').matches) {
      return;
    }

    var purchaseActions = document.querySelector('.ProductForm__PurchaseActions');
    var addToCartButton = purchaseActions ? purchaseActions.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)') : document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
    
    if (!addToCartButton || !purchaseActions) {
      return;
    }

    // Assign to function-scope variables so updateStickyButton() can access them
    realButton = addToCartButton;

    // Create card container for sticky button
    var stickyCard = document.createElement('div');
    stickyCard.classList.add('StickyAddToCartCard');
    stickyCard.style.display = 'none'; // Hidden by default
    
    // Create duplicate sticky button (cloneNode(false) to avoid cloning event listeners)
    stickyButton = realButton.cloneNode(false);
    // Manually add the span back so the text sync still works
    stickyButton.innerHTML = '<span>' + realButton.textContent.trim() + '</span>';
    stickyButton.classList.add('ProductForm__AddToCart--sticky');
    
    // Add button to card, then card to body
    stickyCard.appendChild(stickyButton);
    document.body.appendChild(stickyCard);

    // Helper function to attach click handler to sticky button (reusable)
    function attachStickyButtonClickHandler(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't proceed if button is disabled
        if (realButton && realButton.disabled) {
          return;
        }
        
        // Find the product form
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (!productForm) {
          return;
        }
        
        // Disable both buttons
        realButton.setAttribute('disabled', 'disabled');
        button.setAttribute('disabled', 'disabled');
        
        // Show loading state
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
        // Serialize form data
        var formData = serializeForm(productForm);
        
        // Submit via AJAX
        fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function(response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          return response.json();
        }).then(function(data) {
          // Get variant ID and quantity from form data
          var variantId = formData.id;
          var quantity = parseInt(formData.quantity || 1);
          
          // Try to get full variant object from ProductVariants instance if available
          var variant = { id: variantId };
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Check if ProductVariants instance exists and has currentVariant
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              variant = productVariantsData.currentVariant;
            }
          }
          
          // Dispatch product:added event (this triggers cart drawer update and opening)
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant,
              quantity: quantity
            }
          }));
          
          // Also dispatch cart:refresh on documentElement as fallback
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }).catch(function(error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons on error
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          console.error('Error adding to cart:', error);
        });
      });
    }

    // Helper function to serialize form data
    function serializeForm(form) {
      var formData = {};
      var inputs = form.querySelectorAll('input, select, textarea');
      
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.name && !input.disabled) {
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked) {
              formData[input.name] = input.value;
            }
          } else {
            formData[input.name] = input.value;
          }
        }
      }
      
      return formData;
    }

    // Make sticky button submit the form directly via AJAX
    attachStickyButtonClickHandler(stickyButton);

    // Function to show sticky button with fade in
    function showSticky() {
      if (!isStickyVisible) {
        // Get current variant and update sticky button from variant data
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (productForm) {
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Try to get current variant from ProductVariants instance
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              updateStickyButtonFromVariant(productVariantsData.currentVariant);
            } else {
              // Fallback: try to get variant from form
              var variantIdInput = productForm.querySelector('input[name="id"]');
              if (variantIdInput && variantIdInput.value) {
                // Try to find variant in product data
                var productData = productFormContainer.querySelector('[data-product-json]');
                if (productData) {
                  try {
                    var product = JSON.parse(productData.textContent);
                    var variant = product.variants.find(function(v) {
                      return v.id.toString() === variantIdInput.value.toString();
                    });
                    if (variant) {
                      updateStickyButtonFromVariant(variant);
                    }
                  } catch (e) {
                    console.error('Error parsing product data:', e);
                  }
                }
              }
            }
          }
        }
        
        // Show card with fade in
        stickyCard.style.display = '';
        stickyCard.style.opacity = '0';
        requestAnimationFrame(function() {
          stickyCard.style.transition = 'opacity 0.3s ease-in-out';
          stickyCard.style.opacity = '1';
        });
        
        isStickyVisible = true;
      }
    }

    // Function to hide sticky button instantly (no fade)
    function hideSticky() {
      if (isStickyVisible) {
        stickyCard.style.transition = 'none';
        stickyCard.style.display = 'none';
        stickyCard.style.opacity = '0';
        isStickyVisible = false;
      }
    }

    // Helper function to attach click handler to sticky button
    function attachStickyButtonClickHandler(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Don't proceed if button is disabled
        if (realButton && realButton.disabled) {
          return;
        }
        
        // Find the product form
        var productForm = document.querySelector('form.ProductForm[action*="/cart/add"]');
        if (!productForm) {
          return;
        }
        
        // Disable both buttons
        realButton.setAttribute('disabled', 'disabled');
        button.setAttribute('disabled', 'disabled');
        
        // Show loading state
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
        // Serialize form data
        var formData = serializeForm(productForm);
        
        // Submit via AJAX
        fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function(response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          return response.json();
        }).then(function(data) {
          // Get variant ID and quantity from form data
          var variantId = formData.id;
          var quantity = parseInt(formData.quantity || 1);
          
          // Try to get full variant object from ProductVariants instance if available
          var variant = { id: variantId };
          var productFormContainer = productForm.closest('[data-section-type="product"]') || productForm.closest('.Product');
          if (productFormContainer) {
            // Check if ProductVariants instance exists and has currentVariant
            var productVariantsData = productFormContainer.ProductVariants || 
                                     (window.theme && window.theme.productVariants) ||
                                     (productFormContainer.querySelector && productFormContainer.querySelector('[data-product-variants]'));
            
            if (productVariantsData && productVariantsData.currentVariant) {
              variant = productVariantsData.currentVariant;
            }
          }
          
          // Dispatch product:added event (this triggers cart drawer update and opening)
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant,
              quantity: quantity
            }
          }));
          
          // Also dispatch cart:refresh on documentElement as fallback
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }).catch(function(error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          // Re-enable buttons on error
          if (realButton) {
            realButton.removeAttribute('disabled');
          }
          if (button) {
            button.removeAttribute('disabled');
          }
          
          console.error('Error adding to cart:', error);
        });
      });
    }

    // Update sticky button when real button changes (variant selection, etc.)
    // Always update regardless of visibility so it has correct data when it appears
    function updateStickyButton() {
      // Re-find buttons if references are lost
      if (!realButton) {
        realButton = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
      }
      if (!stickyButton) {
        stickyButton = document.querySelector('.ProductForm__AddToCart--sticky');
      }
      
      if (!realButton || !stickyButton) return;
      
      // Sync text/HTML content
      // We use innerHTML to ensure icons and spans are all preserved
      var stickySpan = stickyButton.querySelector('span');
      var realSpan = realButton.querySelector('span');
      
      if (stickySpan && realSpan) {
        stickySpan.innerHTML = realSpan.innerHTML;
      } else {
        stickyButton.innerHTML = realButton.innerHTML;
      }
      
      // Sync disabled state
      if (realButton.hasAttribute('disabled')) {
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.disabled = true;
      } else {
        stickyButton.removeAttribute('disabled');
        stickyButton.disabled = false;
      }
      
      // Sync classes (important for 'is-loading' states)
      stickyButton.className = realButton.className + ' ProductForm__AddToCart--sticky';
    }

    // Helper function to update sticky button from variant data
    function updateStickyButtonFromVariant(variant) {
      if (!variant || !stickyButton) return;

      var stickySpan = stickyButton.querySelector('span');
      var targetElement = stickySpan || stickyButton;

      if (variant.available) {
        var availableLabel = (window.languages && window.languages.productFormAddToCart) || 'Add to Bag';

        targetElement.textContent = swlVariantIsPreorder(variant) ? swlPreorderLabel() : availableLabel;
        stickyButton.removeAttribute('disabled');
        stickyButton.disabled = false;
        stickyButton.classList.remove('Button--secondary');
        stickyButton.classList.add('Button--primary');
      } else {
        targetElement.textContent = 'Sold Out';
        stickyButton.setAttribute('disabled', 'disabled');
        stickyButton.disabled = true;
        stickyButton.classList.remove('Button--primary');
        stickyButton.classList.add('Button--secondary');
      }
      
      console.log('Sticky button forced update:', variant.available ? 'Available' : 'Sold Out');
    }

    // Listen for variant changes to update sticky button directly from variant data

    // Function to check if sticky button is 100% on top of real button (perfectly aligned)
    // Used for scroll down behavior
    function isStickyAlignedWithRealButton() {
      var realButtonRect = purchaseActions.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      
      // Sticky button is positioned at bottom: 20px, so its bottom edge is at viewportHeight - 20px
      var stickyButtonBottomPosition = viewportHeight - 20;
      
      // Get real button height
      var realButtonHeight = realButtonRect.height;
      var realButtonBottom = realButtonRect.bottom;
      var realButtonTop = realButtonRect.top;
      
      // Check if real button's bottom edge aligns with sticky button's bottom position
      // Allow a small tolerance (10px) for smooth transition
      var alignmentTolerance = 10;
      
      // Sticky is aligned when:
      // 1. Real button's bottom edge is at or near the sticky button's bottom position
      // 2. Real button is actually visible (not scrolled past)
      var isBottomAligned = realButtonBottom >= (stickyButtonBottomPosition - alignmentTolerance) && 
                           realButtonBottom <= (stickyButtonBottomPosition + alignmentTolerance);
      
      // Real button is visible if any part is in viewport
      var isRealButtonVisible = realButtonTop < viewportHeight && realButtonBottom > 0;
      
      return isBottomAligned && isRealButtonVisible;
    }

    // Function to check if real button is visible on screen
    // Used for scroll up behavior (previous behavior)
    function isRealButtonVisible() {
      var rect = purchaseActions.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      // Button is visible if any part of it is within the viewport
      return rect.top < viewportHeight && rect.bottom > 0;
    }

    // Function to check if real button is above viewport (scrolled past going down)
    function isRealButtonAboveViewport() {
      var rect = purchaseActions.getBoundingClientRect();
      // Button is above viewport if its bottom edge is above the viewport top
      return rect.bottom < 0;
    }

    // Intersection Observer to detect when real button is out of view
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          // Real button is out of view - only show sticky if it's above viewport (scrolled past going down)
          if (isRealButtonAboveViewport()) {
            showSticky();
          } else {
            // Real button is below viewport - hide sticky
            hideSticky();
          }
        }
        // Don't hide based on intersection alone - wait for perfect alignment
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });

    // Observe the purchase actions container
    observer.observe(purchaseActions);

    // Track scroll direction
    var lastScrollY = window.scrollY;
    var scrollDirection = 'down'; // 'up' or 'down'

    // Check on scroll to detect when sticky should hide/show
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      // Determine scroll direction
      var currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        scrollDirection = 'down';
      } else if (currentScrollY < lastScrollY) {
        scrollDirection = 'up';
      }
      lastScrollY = currentScrollY;

      // Debounce scroll checks
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        if (isStickyVisible) {
          // Different behavior based on scroll direction
          if (scrollDirection === 'down') {
            // Scroll down: Hide when sticky is 100% aligned with real button
            if (isStickyAlignedWithRealButton()) {
              // Sticky is 100% on top of real button - hide instantly for seamless transition
              hideSticky();
            }
          } else {
            // Scroll up: Hide when real button becomes visible (previous behavior)
            if (isRealButtonVisible()) {
              // Real button is visible - hide sticky instantly
              hideSticky();
            }
          }
        } else {
          // Check if real button is above viewport (scrolled past going down) - show sticky
          if (isRealButtonAboveViewport()) {
            showSticky();
          }
        }
      }, 10); // Small delay to batch scroll events
    }, { passive: true });

    // Initial check - if real button is above viewport on load, show sticky
    if (isRealButtonAboveViewport()) {
      showSticky();
    }

    // Clean up on page unload
    window.addEventListener('beforeunload', function() {
      observer.disconnect();
      if (stickyCard && stickyCard.parentNode) {
        stickyCard.parentNode.removeChild(stickyCard);
      }
    });

    // Add click handler to stickyCard (handles clicks even if button is replaced)
    // Use capture phase to catch the click first and stop any other listeners
    if (stickyCard) {
      stickyCard.addEventListener('click', function(e) {
        var btn = e.target.closest('.ProductForm__AddToCart--sticky');
        if (btn) {
          e.preventDefault();
          e.stopImmediatePropagation(); // Stop any other listeners
          var realBtn = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
          if (realBtn) {
            console.log('Proxy Click: Triggering real button');
            realBtn.click();
          }
        }
      }, true); // Use capture phase to catch the click first
    }

    // Heartbeat Sync: Check every 500ms and force the sticky button to match the real button
    setInterval(function() {
      var realBtn = document.querySelector('.ProductForm__AddToCart:not(.ProductForm__AddToCart--sticky)');
      var stickyBtn = document.querySelector('.ProductForm__AddToCart--sticky');
      
      if (!realBtn || !stickyBtn) return;

      // Sync Text
      var realText = realBtn.textContent.trim();
      var stickySpan = stickyBtn.querySelector('span');
      var target = stickySpan || stickyBtn;
      
      if (target.textContent.trim() !== realText) {
        target.textContent = realText;
        console.log('Heartbeat Sync: Updated text to ' + realText);
      }

      // Sync Disabled State
      if (realBtn.disabled !== stickyBtn.disabled) {
        stickyBtn.disabled = realBtn.disabled;
        if (realBtn.disabled) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
      }
    }, 500);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initStickyAddToCart, 100);
  });
})();

/**
 * Desktop product page: stop Prestige from shifting the buy column on
 * scroll. Gallery and Add to Bag are CSS sticky, like collection filters.
 */
(function() {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 1008px)');

  function lockStickyGalleryInfo() {
    if (document.querySelector('.Product--stickyGallery') && desktopQuery.matches) {
      document.documentElement.setAttribute('data-swl-lock-info', 'true');

      var wrapper = document.querySelector('.Product--stickyGallery .Product__Wrapper');
      var aside = document.querySelector('.Product--stickyGallery .Product__Aside');

      if (wrapper) {
        wrapper.style.minHeight = '';
      }

      if (aside) {
        aside.style.minHeight = '';
      }
    }
  }

  function start() {
    lockStickyGalleryInfo();
    window.setTimeout(lockStickyGalleryInfo, 50);
    window.setTimeout(lockStickyGalleryInfo, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', lockStickyGalleryInfo);
  document.addEventListener('shopify:section:load', function() {
    setTimeout(start, 100);
  });
})();

/**
 * Smooth fade transition for product price on variant change
 * Uses MutationObserver to catch the moment the theme clears/updates the price HTML
 */
(function() {
  'use strict';

  var priceList = document.querySelector('.ProductMeta__PriceList');
  if (priceList) {
    var priceObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Target only the price elements, not the whole container
          var prices = priceList.querySelectorAll('.ProductMeta__Price');
          
          prices.forEach(function(price) {
            price.style.transition = 'none';
            price.style.opacity = '0';
            
            setTimeout(function() {
              price.style.transition = 'opacity 0.3s ease-in-out';
              price.style.opacity = '1';
            }, 50);
          });
        }
      });
    });

    priceObserver.observe(priceList, { childList: true });
  }
})();

/**
 * Cart Drawer & Cart Page - Gift Message Handler
 * Note: Sticky footer is handled via CSS position: sticky
 */
(function() {
  'use strict';

  var saveTimeout = null;
  var lastSavedMessage = null;
  var isFlushingOnSubmit = false;

  function isGiftMessageTextarea(el) {
    if (!el || el.tagName !== 'TEXTAREA') return false;
    return el.id === 'cart-drawer-gift-message' || el.id === 'cart-page-gift-message';
  }

  function saveGiftMessage(message) {
    if (!window.routes || !window.routes.cartUrl) return Promise.resolve();

    var formData = {
      note: message,
      // Migration: clear the old cart attribute so it stops appearing under "Additional details"
      attributes: { 'Gift Message': '' }
    };

    return fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    }).then(function() {
      lastSavedMessage = message;
    }).catch(function(error) {
      console.error('Error saving gift message:', error);
    });
  }

  // Save gift message to cart note (order notes) using event delegation
  function setupGiftMessage() {
    if (!window.routes || !window.routes.cartUrl) return;

    // Save while typing (debounced) so checkout doesn't race the save
    document.addEventListener('input', function(event) {
      var giftMessageInput = event.target;
      if (!isGiftMessageTextarea(giftMessageInput)) return;

      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(function() {
        saveGiftMessage(giftMessageInput.value.trim());
      }, 300);
    }, true);

    // Also save on blur as a backstop
    document.addEventListener('blur', function(event) {
      var giftMessageInput = event.target;
      if (!isGiftMessageTextarea(giftMessageInput)) return;

      clearTimeout(saveTimeout);
      saveGiftMessage(giftMessageInput.value.trim());
    }, true); // Use capture phase for event delegation

    // Ensure we flush the latest message before checkout submit happens
    document.addEventListener('submit', function(event) {
      if (isFlushingOnSubmit) return;
      if (!event || !event.target) return;

      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;

      var giftMessageInput = form.querySelector('#cart-drawer-gift-message, #cart-page-gift-message');
      if (!giftMessageInput) return;

      var message = giftMessageInput.value.trim();
      if (message === (lastSavedMessage || '')) return;

      event.preventDefault();
      event.stopPropagation();
      clearTimeout(saveTimeout);

      saveGiftMessage(message).finally(function() {
        // Re-trigger the original submit button click (keeps name="checkout" behaviour).
        isFlushingOnSubmit = true;
        var submitter = event.submitter;
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        } else if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }

        // Safety: if the page doesn't navigate (edge cases), allow future submits.
        setTimeout(function() { isFlushingOnSubmit = false; }, 1500);
      });
    }, true);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftMessage);
  } else {
    setupGiftMessage();
  }
})();

/**
 * Cart Drawer & Cart Page - Gift Message Toggle (Accordion)
 * Using event delegation to handle AJAX cart updates
 */
(function() {
  'use strict';

  function handleGiftToggleClick(e) {
    var giftToggle = e.target.closest('.cart-drawer__gift-toggle');
    if (!giftToggle) return;

    e.preventDefault();
    e.stopPropagation();
    
    var contentId = giftToggle.getAttribute('aria-controls');
    if (!contentId) return;

    var content = document.getElementById(contentId);
    if (!content) return;

    var isExpanded = giftToggle.getAttribute('aria-expanded') === 'true';
    
    giftToggle.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    
    // Auto-focus textarea when expanded
    if (!isExpanded) {
      setTimeout(function() {
        var textarea = content.querySelector('textarea');
        if (textarea) textarea.focus();
      }, 150);
    }
  }

  // Use event delegation on the cart drawer container
  function setupGiftMessageToggle() {
    var cartDrawer = document.getElementById('sidebar-cart');
    if (cartDrawer) {
      // Remove old listener if exists, then add new one
      cartDrawer.removeEventListener('click', handleGiftToggleClick);
      cartDrawer.addEventListener('click', handleGiftToggleClick);
    }

    // Also handle cart page
    var cartPage = document.querySelector('.cart-page-form, .Cart--expanded');
    if (cartPage) {
      cartPage.removeEventListener('click', handleGiftToggleClick);
      cartPage.addEventListener('click', handleGiftToggleClick);
    }

    // Auto-expand if message already exists
    var giftToggles = document.querySelectorAll('.cart-drawer__gift-toggle');
    giftToggles.forEach(function(giftToggle) {
      var contentId = giftToggle.getAttribute('aria-controls');
      if (!contentId) return;
      var content = document.getElementById(contentId);
      if (!content) return;
      var textarea = content.querySelector('textarea');
      if (textarea && textarea.value.trim()) {
        giftToggle.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
      }
    });
  }

  // Use document-level event delegation as a fallback for cart page
  // This ensures it works even if setupGiftMessageToggle hasn't run yet
  // or when navigating to cart page after adding an item
  document.addEventListener('click', function(e) {
    // Only handle if it's a gift toggle button
    var giftToggle = e.target.closest('.cart-drawer__gift-toggle');
    if (!giftToggle) return;
    
    // Check if we're on the cart page
    var isCartPage = document.querySelector('.cart-page-form, .Cart--expanded');
    if (!isCartPage) return;
    
    // Only handle if the click is within the cart page form
    var cartPageForm = giftToggle.closest('.cart-page-form, .Cart--expanded');
    if (!cartPageForm) return;
    
    // Call the handler
    handleGiftToggleClick(e);
  }, true); // Use capture phase to ensure we catch it early

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGiftMessageToggle);
  } else {
    setupGiftMessageToggle();
  }

  // Re-initialize when cart drawer opens or refreshes
  document.addEventListener('cart:refresh', function() {
    setTimeout(setupGiftMessageToggle, 100);
  });
  
  // Also listen for drawer open events
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        var drawer = document.getElementById('sidebar-cart');
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          setTimeout(setupGiftMessageToggle, 100);
        }
      }
    });
  });

  var drawer = document.getElementById('sidebar-cart');
  if (drawer) {
    observer.observe(drawer, { attributes: true });
  }

  // Watch for cart page form appearing (for AJAX navigation or dynamic loading)
  var cartPageObserver = new MutationObserver(function(mutations) {
    var cartPageForm = document.querySelector('.cart-page-form, .Cart--expanded');
    if (cartPageForm) {
      setupGiftMessageToggle();
    }
  });

  // Observe the main content area for cart page
  var mainContent = document.querySelector('main, .PageContainer, body');
  if (mainContent) {
    cartPageObserver.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }

  // Also initialize for cart page on load with multiple attempts
  if (document.querySelector('.cart-page-form')) {
    setTimeout(setupGiftMessageToggle, 100);
    setTimeout(setupGiftMessageToggle, 500);
    setTimeout(setupGiftMessageToggle, 1000);
  }

  // Re-initialize when page becomes visible (handles navigation to cart page)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden && document.querySelector('.cart-page-form')) {
      setTimeout(setupGiftMessageToggle, 100);
    }
  });

  // Also listen for popstate (browser back/forward) and pageshow events
  window.addEventListener('pageshow', function() {
    if (document.querySelector('.cart-page-form')) {
      setTimeout(setupGiftMessageToggle, 100);
    }
  });
})();

/**
 * Desktop header: hide on scroll down, show on scroll up.
 * Mobile / tablet (below 1140px) are left untouched.
 */
(function() {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 1140px)';
  var SHOW_AT_TOP = 80;
  var DELTA = 8;
  var desktopQuery = window.matchMedia(DESKTOP_QUERY);
  var headerSection = document.getElementById('shopify-section-header');
  var lastY = window.pageYOffset;
  var concealed = false;
  var ticking = false;

  if (!headerSection) {
    return;
  }

  function isDesktop() {
    return desktopQuery.matches;
  }

  function isStickyEnabled() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--use-sticky-header') || '0', 10) === 1;
  }

  function isChromeOpen() {
    if (document.documentElement.classList.contains('no-scroll')) {
      return true;
    }

    if (document.querySelector('.Search[aria-hidden="false"]')) {
      return true;
    }

    if (document.querySelector('.Header__MainNav [aria-hidden="false"]')) {
      return true;
    }

    if (headerSection.matches(':hover')) {
      return true;
    }

    return false;
  }

  function setConcealed(hide) {
    if (concealed === hide) {
      return;
    }

    concealed = hide;
    document.documentElement.classList.toggle('is-header-concealed', hide);
  }

  function reveal() {
    setConcealed(false);
  }

  function applyLandingState(event) {
    lastY = window.pageYOffset;

    var isFirstImage = event && event.detail && event.detail.isFirstImage;
    var keepHeader = event && event.detail && event.detail.keepHeader;
    var leaveHeader = event && event.detail && event.detail.leaveHeader;

    if (leaveHeader) {
      return;
    }

    if (!isDesktop() || !isStickyEnabled() || isChromeOpen() || isFirstImage || keepHeader) {
      reveal();
      return;
    }

    setConcealed(true);
  }

  function onScroll() {
    var y = window.pageYOffset;

    if (document.documentElement.getAttribute('data-swl-programmatic-scroll') === 'true') {
      lastY = y;
      return;
    }

    if (!isDesktop() || !isStickyEnabled()) {
      reveal();
      lastY = y;
      return;
    }

    if (y <= SHOW_AT_TOP || isChromeOpen()) {
      reveal();
      lastY = y;
      return;
    }

    var travelled = y - lastY;

    if (travelled > DELTA) {
      setConcealed(true);
    } else if (travelled < -DELTA) {
      reveal();
    }

    lastY = y;
  }

  function requestScrollTick() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(function() {
      onScroll();
      ticking = false;
    });
  }

  window.addEventListener('scroll', requestScrollTick, { passive: true });
  document.addEventListener('swl:programmatic-scroll-end', applyLandingState);
  document.addEventListener('swl:header-conceal', function() {
    if (!isDesktop() || !isStickyEnabled()) {
      return;
    }

    setConcealed(true);
  });
  document.addEventListener('swl:header-reveal', function() {
    reveal();
  });

  headerSection.addEventListener('mouseenter', reveal);

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', function() {
      if (!desktopQuery.matches) {
        reveal();
      }
    });
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(function() {
      if (!desktopQuery.matches) {
        reveal();
      }
    });
  }
})();

/**
 * Collection swatches land on ?variant= with a gallery hash.
 * Prestige product media uses #Media{id}, not #Image{id}, so the hash
 * used to miss and the first product photo stayed on screen.
 * On load, show the selected variant's media the same way a product swatch does.
 */
(function() {
  'use strict';

  function getSelectedVariant() {
    var jsonEl = document.querySelector('[data-product-json]');

    if (!jsonEl) {
      return null;
    }

    try {
      var data = JSON.parse(jsonEl.textContent);
      var selectedId = data.selected_variant_id;
      var variants = (data.product && data.product.variants) || [];

      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) {
          return variants[i];
        }
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getVariantMediaId(variant) {
    if (!variant) {
      return null;
    }

    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }

    var hash = window.location.hash || '';

    if (hash.indexOf('#Media') === 0) {
      return hash.replace('#Media', '');
    }

    return null;
  }

  function showSelectedVariantMedia() {
    var section = document.querySelector('[data-section-type="product"]');

    if (!section) {
      return;
    }

    var mediaId = getVariantMediaId(getSelectedVariant());

    if (!mediaId) {
      return;
    }

    var slide = section.querySelector('.Product__SlideItem[data-media-id="' + mediaId + '"]');

    if (!slide) {
      return;
    }

    var firstSlide = section.querySelector('.Product__SlideItem');

    if (firstSlide && firstSlide.getAttribute('data-media-id') === mediaId && slide.classList.contains('is-selected')) {
      return;
    }

    if (window.matchMedia('(min-width: 1008px)').matches && section.querySelector('.Product__Gallery--stack')) {
      document.dispatchEvent(new CustomEvent('swl:scroll-to-media', {
        detail: {
          mediaId: mediaId,
          instant: true,
          keepHeader: true
        }
      }));
      return;
    }

    var navLink = section.querySelector('.Product__SlideshowNavImage[data-media-id="' + mediaId + '"], .Product__SlideshowNavDot[href="#Media' + mediaId + '"]');

    if (navLink) {
      navLink.click();
      return;
    }

    var slideshow = section.querySelector('.Product__Slideshow');
    var flickity = slideshow && (slideshow.flickity || slideshow.Flickity);

    if (flickity && typeof flickity.select === 'function') {
      var cells = slideshow.querySelectorAll('.Product__SlideItem');

      for (var i = 0; i < cells.length; i++) {
        if (cells[i].getAttribute('data-media-id') === mediaId) {
          flickity.select(i);
          break;
        }
      }
    }
  }

  function init() {
    window.requestAnimationFrame(showSelectedVariantMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Colour swatches scroll the stacked gallery. Pin the buy box on screen
 * for that jump only; release it on the next real user scroll.
 */
(function() {
  'use strict';

  var skipMediaPageScroll = false;
  var lockStartedAt = 0;
  var pinnedInfo = null;
  var savedScrollerTop = null;
  var settleTimer = null;
  var settleRaf = null;
  var desktopQuery = window.matchMedia('(min-width: 1008px)');
  var pinProperties = [
    'position',
    'top',
    'left',
    'right',
    'width',
    'transform',
    'will-change',
    'z-index',
    '-webkit-backface-visibility',
    'backface-visibility',
    'background-color',
    'margin'
  ];

  function getVariantMediaId(variant) {
    if (!variant) {
      return null;
    }

    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }

    if (variant.featured_image && variant.featured_image.id) {
      return String(variant.featured_image.id);
    }

    return null;
  }

  function isFirstStackedMedia(mediaId) {
    var first = document.querySelector('[data-section-type="product"] .Product__Gallery--stack .Product__SlideItem');

    return !!(first && mediaId && first.getAttribute('data-media-id') === String(mediaId));
  }

  function stickyAnnouncementOffset() {
    var value = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-sticky-offset'), 10);

    return isNaN(value) ? 0 : value;
  }

  function headerOffset(isFirstImage) {
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    var announcement = stickyAnnouncementOffset();

    if (isNaN(header)) {
      header = 0;
    }

    if (!isFirstImage && document.documentElement.classList.contains('is-header-concealed')) {
      return 25;
    }

    return header + announcement + 25;
  }

  function beginProgrammaticScroll() {
    document.documentElement.setAttribute('data-swl-programmatic-scroll', 'true');
  }

  function cancelSettleWait() {
    window.clearTimeout(settleTimer);
    settleTimer = null;

    if (settleRaf) {
      window.cancelAnimationFrame(settleRaf);
      settleRaf = null;
    }
  }

  function endProgrammaticScroll(userTookOver, isFirstImage, keepHeader, leaveHeader) {
    cancelSettleWait();
    skipMediaPageScroll = false;

    if (document.documentElement.getAttribute('data-swl-programmatic-scroll') !== 'true') {
      return;
    }

    document.documentElement.removeAttribute('data-swl-programmatic-scroll');

    if (!pinnedInfo) {
      setOverflowLock(false);
    }

    if (!userTookOver) {
      document.dispatchEvent(new CustomEvent('swl:programmatic-scroll-end', {
        detail: {
          isFirstImage: !!isFirstImage,
          keepHeader: !!keepHeader,
          leaveHeader: !!leaveHeader
        }
      }));
    }
  }

  function waitForScrollSettle(targetY, isFirstImage, keepHeader, leaveHeader) {
    var start = Date.now();

    cancelSettleWait();

    function tick() {
      if (document.documentElement.getAttribute('data-swl-programmatic-scroll') !== 'true') {
        settleRaf = null;
        return;
      }

      var settled = Math.abs(window.pageYOffset - targetY) < 4;
      var timedOut = Date.now() - start > 2500;

      if (settled || timedOut) {
        settleRaf = null;
        endProgrammaticScroll(false, isFirstImage, keepHeader, leaveHeader);
        return;
      }

      settleRaf = window.requestAnimationFrame(tick);
    }

    settleRaf = window.requestAnimationFrame(tick);
  }

  function getInfo() {
    return document.querySelector('[data-section-type="product"] .Product__Info');
  }

  function setOverflowLock(locked) {
    if (locked) {
      document.documentElement.setAttribute('data-swl-lock-info', 'true');
      window.dispatchEvent(new Event('scroll'));
    } else if (!(document.querySelector('.Product--stickyGallery') && desktopQuery.matches)) {
      document.documentElement.removeAttribute('data-swl-lock-info');
    }
  }

  function pinInfo() {
    var info = getInfo();

    if (!info || !desktopQuery.matches) {
      return false;
    }

    if (info.classList.contains('Product__Info--swatchPinned')) {
      lockStartedAt = Date.now();
      setOverflowLock(true);
      pinnedInfo = info;
      return true;
    }

    savedScrollerTop = info.style.top;
    var rect = info.getBoundingClientRect();

    if (rect.width < 1 || rect.height < 1) {
      return false;
    }

    var spacer = document.createElement('div');
    spacer.setAttribute('data-swl-info-spacer', '');
    spacer.style.height = info.offsetHeight + 'px';
    spacer.style.width = '100%';
    spacer.style.visibility = 'hidden';
    spacer.style.pointerEvents = 'none';
    info.parentNode.insertBefore(spacer, info);

    info.classList.add('Product__Info--swatchPinned');
    info.style.setProperty('position', 'fixed', 'important');
    info.style.setProperty('top', rect.top + 'px', 'important');
    info.style.setProperty('left', rect.left + 'px', 'important');
    info.style.setProperty('width', rect.width + 'px', 'important');
    info.style.setProperty('right', 'auto', 'important');
    info.style.setProperty('margin', '0', 'important');
    info.style.setProperty('transform', 'none', 'important');
    info.style.setProperty('will-change', 'auto', 'important');
    info.style.setProperty('z-index', '4', 'important');
    info.style.setProperty('-webkit-backface-visibility', 'visible', 'important');
    info.style.setProperty('backface-visibility', 'visible', 'important');
    info.style.setProperty('background-color', 'var(--background, #ffffff)', 'important');

    pinnedInfo = info;
    lockStartedAt = Date.now();
    setOverflowLock(true);
    return true;
  }

  function unpinInfo() {
    var info = pinnedInfo || getInfo();
    var spacer = document.querySelector('[data-swl-info-spacer]');

    if (spacer) {
      spacer.parentNode.removeChild(spacer);
    }

    if (info) {
      info.classList.remove('Product__Info--swatchPinned');

      for (var i = 0; i < pinProperties.length; i++) {
        info.style.removeProperty(pinProperties[i]);
      }

      if (savedScrollerTop) {
        info.style.top = savedScrollerTop;
      }
    }

    pinnedInfo = null;
    savedScrollerTop = null;
    setOverflowLock(false);
  }

  function freezeInfoColumn() {
    if (!desktopQuery.matches) {
      return;
    }

    if (!document.querySelector('[data-section-type="product"] .Product__Gallery--stack')) {
      return;
    }

    skipMediaPageScroll = true;
    beginProgrammaticScroll();
    pinInfo();
  }

  function goToStackedImage(mediaId, options) {
    var section = document.querySelector('[data-section-type="product"]');

    options = options || {};

    if (!section || !mediaId || !desktopQuery.matches) {
      return false;
    }

    if (!section.querySelector('.Product__Gallery--stack')) {
      return false;
    }

    var slide = section.querySelector('.Product__SlideItem[data-media-id="' + mediaId + '"]');

    if (!slide) {
      return false;
    }

    var isFirstImage = isFirstStackedMedia(mediaId);
    var rawTop = slide.getBoundingClientRect().top + window.pageYOffset;
    var top = Math.max(0, rawTop - headerOffset(isFirstImage));

    window.scrollTo({
      top: top,
      behavior: options.instant ? 'auto' : 'smooth'
    });

    waitForScrollSettle(top, isFirstImage, options.keepHeader, options.leaveHeader);
    return true;
  }

  function scrollToPinnedMedia(mediaId, options) {
    options = options || {};

    if (!desktopQuery.matches || !mediaId) {
      return false;
    }

    if (!document.querySelector('[data-section-type="product"] .Product__Gallery--stack')) {
      return false;
    }

    var isFirstImage = isFirstStackedMedia(mediaId);
    var keepHeader = !!options.keepHeader;
    var leaveHeader = !!options.leaveHeader;

    freezeInfoColumn();

    if (!goToStackedImage(mediaId, {
      instant: !!options.instant,
      keepHeader: keepHeader,
      leaveHeader: leaveHeader
    })) {
      endProgrammaticScroll(false, isFirstImage, keepHeader, leaveHeader);
      skipMediaPageScroll = false;
      return false;
    }

    return true;
  }

  function unlockOnUserScroll() {
    if (pinnedInfo && Date.now() - lockStartedAt < 80) {
      return;
    }

    if (pinnedInfo) {
      unpinInfo();
    }

    endProgrammaticScroll(true);
  }

  window.addEventListener('wheel', unlockOnUserScroll, { passive: true });
  window.addEventListener('touchmove', unlockOnUserScroll, { passive: true });
  window.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'PageUp' || event.key === 'PageDown' || event.key === 'Home' || event.key === 'End' || event.key === ' ') {
      unlockOnUserScroll();
    }
  });
  window.addEventListener('resize', function() {
    if (pinnedInfo) {
      unpinInfo();
    }

    endProgrammaticScroll(true);
  });

  document.addEventListener('pointerdown', function(event) {
    if (!event.target.closest('.Product__Info .ColorSwatch, .Product__Info .ColorSwatch__Radio')) {
      return;
    }

    freezeInfoColumn();
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail && event.detail.variant;
    var previousVariant = event.detail && event.detail.previousVariant;
    var mediaId = getVariantMediaId(variant);
    var previousMediaId = getVariantMediaId(previousVariant);

    if (!mediaId || mediaId === previousMediaId) {
      return;
    }

    scrollToPinnedMedia(mediaId, { leaveHeader: true });
  }, true);

  document.addEventListener('swl:scroll-to-media', function(event) {
    var mediaId = event.detail && event.detail.mediaId;

    if (!mediaId) {
      return;
    }

    scrollToPinnedMedia(mediaId, {
      keepHeader: !!(event.detail && event.detail.keepHeader),
      instant: !!(event.detail && event.detail.instant),
      leaveHeader: !!(event.detail && event.detail.leaveHeader)
    });
  });

  document.addEventListener('click', function(event) {
    if (!skipMediaPageScroll) {
      return;
    }

    var link = event.target.closest('a[href^="#Media"]');

    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

(function() {
  'use strict';

  var addedLabel = 'Added';

  function serializeCardForm(form) {
    var data = {};
    var fields = form.querySelectorAll('input, select, textarea');

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];

      if (!field.name || field.disabled) {
        continue;
      }

      data[field.name] = field.value;
    }

    return data;
  }

  function addFromCard(form, button) {
    var formData = serializeCardForm(form);
    var variantId = formData.id;
    var quantity = parseInt(formData.quantity || '1', 10) || 1;

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (!response.ok) {
        button.removeAttribute('disabled');
        return null;
      }

      button.textContent = addedLabel;

      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: { id: variantId },
          quantity: quantity
        }
      }));

      window.setTimeout(function() {
        button.removeAttribute('disabled');
        button.textContent = button.getAttribute('data-original-label') || 'Add to Bag';
      }, 1600);

      return null;
    }).catch(function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
    });
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.ProductItem__Form');

    if (!form) {
      return;
    }

    var button = form.querySelector('[data-action="add-from-card"]');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (!button.getAttribute('data-original-label')) {
      button.setAttribute('data-original-label', button.textContent.trim());
    }

    addFromCard(form, button);
  });
})();

(function() {
  'use strict';

  function getCells(root) {
    var list = root.querySelector('.ProductList');

    if (!list) {
      return [];
    }

    return Array.prototype.filter.call(list.children, function(cell) {
      return cell.classList.contains('Grid__Cell');
    });
  }

  function visibleCount(root) {
    return parseInt(root.getAttribute('data-show-more-visible') || root.getAttribute('data-show-more-page-size') || '16', 10);
  }

  function pageSize(root) {
    return parseInt(root.getAttribute('data-show-more-page-size') || '16', 10);
  }

  function reveal(root, count) {
    var cells = getCells(root);

    cells.forEach(function(cell, index) {
      if (index < count) {
        cell.classList.add('is-shown');
      }
    });

    root.setAttribute('data-show-more-visible', String(Math.min(count, cells.length)));
    updateNav(root);
  }

  function updateNav(root) {
    var nav = root.querySelector('[data-show-more-nav]');
    var cells = getCells(root);
    var shown = visibleCount(root);
    var hasHidden = shown < cells.length;
    var hasNext = !!root.getAttribute('data-show-more-next');

    if (!nav) {
      return;
    }

    nav.hidden = !hasHidden && !hasNext;
  }

  function appendNextPage(root, button) {
    var nextUrl = root.getAttribute('data-show-more-next');

    if (!nextUrl) {
      updateNav(root);
      return;
    }

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('view', 'ajax');

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(url.toString(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(response) {
      return response.text();
    }).then(function(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      var incomingList = temp.querySelector('.ProductList');
      var currentList = root.querySelector('.ProductList');
      var incomingRoot = temp.querySelector('[data-show-more-root]');

      if (incomingList && currentList) {
        Array.prototype.filter.call(incomingList.children, function(cell) {
          return cell.classList.contains('Grid__Cell');
        }).forEach(function(cell) {
          currentList.appendChild(cell);
        });
      }

      if (incomingRoot && incomingRoot.getAttribute('data-show-more-next')) {
        root.setAttribute('data-show-more-next', incomingRoot.getAttribute('data-show-more-next'));
      } else {
        root.removeAttribute('data-show-more-next');
      }

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
      reveal(root, visibleCount(root) + pageSize(root));
    }).catch(function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
    });
  }

  function showMore(root, button) {
    var cells = getCells(root);
    var nextCount = visibleCount(root) + pageSize(root);

    if (nextCount <= cells.length) {
      reveal(root, nextCount);
      return;
    }

    if (root.getAttribute('data-show-more-next')) {
      appendNextPage(root, button);
      return;
    }

    reveal(root, cells.length);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-show-more-ready') === 'true') {
      return;
    }

    root.setAttribute('data-show-more-ready', 'true');
    root.setAttribute('data-show-more-visible', String(pageSize(root)));
    reveal(root, pageSize(root));
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-show-more-root]');

    for (var i = 0; i < roots.length; i += 1) {
      initRoot(roots[i]);
    }
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="show-more"]');

    if (!button) {
      return;
    }

    var root = button.closest('[data-show-more-root]');

    if (!root) {
      return;
    }

    event.preventDefault();
    showMore(root, button);
  });

  document.addEventListener('theme:loading:end', function() {
    window.setTimeout(initAll, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

(function() {
  'use strict';

  function cardTitle(productItem, colour) {
    var productTitle = productItem.getAttribute('data-product-title') || '';

    if (productItem.classList.contains('ProductItem--colourCard') && productTitle && colour) {
      return productTitle + ' in ' + colour;
    }

    return productTitle;
  }

  function priceHtml(radio) {
    var price = radio.getAttribute('data-price-formatted') || '';
    var compare = radio.getAttribute('data-compare-formatted') || '';
    var priceRaw = parseInt(radio.getAttribute('data-price') || '0', 10);
    var compareRaw = parseInt(radio.getAttribute('data-compare-at-price') || '0', 10);

    if (compare && compareRaw > priceRaw) {
      return '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + price + '</span>' +
        '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' + compare + '</span>';
    }

    return '<span class="ProductItem__Price Price Text--subdued">' + price + '</span>';
  }

  function updateCardFromSwatch(radio) {
    var productItem = radio.closest('.ProductItem');

    if (!productItem) {
      return;
    }

    var colour = radio.value;
    var title = cardTitle(productItem, colour);
    var variantUrl = radio.getAttribute('data-variant-url');
    var variantId = radio.getAttribute('data-variant-id');
    var titleLink = productItem.querySelector('.ProductItem__Title > a');
    var imageLink = productItem.querySelector('.ProductItem__ImageWrapper');
    var image = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    var priceList = productItem.querySelector('.ProductItem__PriceList');
    var form = productItem.querySelector('.ProductItem__Form');
    var idInput = form && form.querySelector('input[name="id"]');
    var soldOut = productItem.querySelector('.ProductItem__Add--soldOut');
    var soldOutLabel = productItem.querySelector('.ProductItem__Label--soldOut');
    var preorderLabel = productItem.querySelector('.ProductItem__Label--preOrder');
    var labelList = productItem.querySelector('.ProductItem__LabelList');
    var addButton = form && form.querySelector('[data-action="add-from-card"]');
    var available = radio.getAttribute('data-available') === 'true';
    var preorder = radio.getAttribute('data-preorder') === 'true';
    var preorderText = (window.languages && window.languages.productFormPreOrder) || 'Pre-Order';
    var addText = (window.languages && window.languages.productFormAddToCart) || 'Add to Bag';

    if (titleLink && title) {
      titleLink.textContent = title;
    }

    if (titleLink && variantUrl) {
      titleLink.setAttribute('href', variantUrl);
    }

    if (imageLink && variantUrl) {
      imageLink.setAttribute('href', variantUrl);
    }

    if (image && title) {
      image.setAttribute('alt', title);
    }

    var imageId = radio.getAttribute('data-image-id');
    var imageUrl = radio.getAttribute('data-image-url');

    if (image && imageUrl && imageId && image.getAttribute('data-image-id') !== imageId) {
      var newImage = document.createElement('img');
      newImage.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImage.setAttribute('data-image-id', imageId);
      newImage.setAttribute('data-src', imageUrl);
      newImage.setAttribute('data-widths', radio.getAttribute('data-image-widths') || '[200,400,600,700,800,900,1000,1200]');
      newImage.setAttribute('data-sizes', 'auto');

      if (title) {
        newImage.setAttribute('alt', title);
      }

      var aspectRatio = radio.getAttribute('data-image-aspect-ratio');

      if (aspectRatio && image.parentNode) {
        image.parentNode.style.setProperty('--aspect-ratio', aspectRatio);
      }

      image.parentNode.replaceChild(newImage, image);

      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(newImage);
      }
    }

    if (priceList && radio.getAttribute('data-price-formatted')) {
      priceList.innerHTML = priceHtml(radio);
    }

    if (idInput && variantId) {
      idInput.value = variantId;
    }

    if (addButton) {
      addButton.textContent = preorder ? preorderText : addText;
      addButton.setAttribute('data-original-label', addButton.textContent.trim());
    }

    if (form) {
      form.hidden = !available;
    }

    if (soldOut) {
      soldOut.hidden = available;
    }

    if (soldOutLabel) {
      soldOutLabel.hidden = available || preorder;
    }

    if (preorderLabel) {
      preorderLabel.hidden = !preorder;
    }

    if (labelList) {
      var visibleLabel = labelList.querySelector('.ProductItem__Label:not([hidden])');
      labelList.hidden = !visibleLabel;
    }
  }

  document.addEventListener('change', function(event) {
    var radio = event.target.closest('.ProductItem .ColorSwatch__Radio');

    if (!radio) {
      return;
    }

    updateCardFromSwatch(radio);
  });
})();

/**
 * Mobile sidebar: chevron drill-in panels. Prestige close still owns the drawer.
 */
(function () {
  const menu = document.getElementById('sidebar-menu');

  if (!menu) {
    return;
  }

  const backButton = menu.querySelector('[data-action="menu-back"]');
  const backLabel = menu.querySelector('[data-menu-back-label]');
  const closeButton = menu.querySelector('[data-action="close-drawer"]');
  const swipeTracks = menu.querySelectorAll('[data-swipe-track]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let menuEntry = false;
  let leaveHref = '';

  const swipeDotsFor = (track) => {
    const swipe = track.closest('.SidebarMenu__Swipe');
    return swipe ? swipe.querySelectorAll('[data-swipe-dots] [data-swipe-index]') : [];
  };

  const setInstant = (on) => {
    menu.classList.toggle('is-instant', on);
  };

  const showPanel = (panelId, title, instant) => {
    const next = menu.querySelector('[data-menu-panel="' + panelId + '"]');

    if (!next) {
      return;
    }

    const current = menu.querySelector('.SidebarMenu__Panel.is-active');
    const isRoot = panelId === 'root';
    const shouldInstant = instant || prefersReducedMotion.matches || current === next;

    if (shouldInstant) {
      setInstant(true);
    }

    for (const panel of menu.querySelectorAll('[data-menu-panel]')) {
      const isActive = panel === next;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    }

    menu.classList.toggle('is-drilled', !isRoot);

    if (backButton) {
      backButton.hidden = isRoot;
    }

    if (backLabel) {
      backLabel.textContent = title || '';
    }

    if (!isRoot) {
      next.scrollTop = 0;
    }

    if (shouldInstant) {
      requestAnimationFrame(() => {
        setInstant(false);
      });
    }
  };

  const unveilSwipeImages = () => {
    if (!window.lazySizes) {
      return;
    }

    for (const track of swipeTracks) {
      for (const image of track.querySelectorAll('img.Image--lazyLoad, img.SidebarMenu__SwipeImage')) {
        if (window.lazySizes.loader.unveil) {
          window.lazySizes.loader.unveil(image);
        }
      }
    }
  };

  const setActiveDot = (track, index) => {
    for (const dot of swipeDotsFor(track)) {
      const isActive = Number(dot.getAttribute('data-swipe-index')) === index;
      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    }
  };

  const syncSwipeDots = (track) => {
    if (!track) {
      return;
    }

    const cards = track.querySelectorAll('.SidebarMenu__SwipeCard');

    if (cards.length === 0) {
      return;
    }

    const cardWidth = cards[0].getBoundingClientRect().width;
    const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    const index = Math.round(track.scrollLeft / (cardWidth + gap));
    setActiveDot(track, Math.max(0, Math.min(index, cards.length - 1)));
  };

  const rememberMenu = (panelId) => {
    if (menuEntry) {
      return;
    }

    try {
      history.pushState({ swlSidebar: panelId }, '', window.location.href);
      menuEntry = true;
    } catch (error) {
      menuEntry = false;
    }
  };

  menu.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const plainClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

    if (link && menuEntry && plainClick && link.target !== '_blank') {
      event.preventDefault();
      event.stopPropagation();
      leaveHref = link.href;
      history.back();
      return;
    }

    const houseToggle = event.target.closest('.SidebarMenu__HouseToggle');

    if (houseToggle && menu.contains(houseToggle)) {
      event.preventDefault();
      event.stopPropagation();

      const accordion = houseToggle.closest('.SidebarMenu__HouseAccordion');
      const content = accordion && accordion.querySelector('.SidebarMenu__HouseContent');
      const expanded = houseToggle.getAttribute('aria-expanded') === 'true';

      houseToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

      if (content) {
        content.setAttribute('aria-hidden', expanded ? 'true' : 'false');
      }

      return;
    }

    const opener = event.target.closest('[data-action="open-menu-panel"]');

    if (opener) {
      event.preventDefault();
      event.stopPropagation();

      const panelId = opener.getAttribute('data-panel');
      const title = opener.getAttribute('data-panel-title') || '';
      const next = panelId && menu.querySelector('[data-menu-panel="' + panelId + '"]');

      if (next && panelId !== 'root') {
        rememberMenu(panelId);
      }

      showPanel(panelId, title);
      return;
    }

    const back = event.target.closest('[data-action="menu-back"]');

    if (back) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (menuEntry) {
        history.back();
      } else {
        showPanel('root');
      }

      return;
    }

    const header = event.target.closest('.SidebarMenu__Header');

    if (header && !menu.classList.contains('is-drilled') && closeButton && !event.target.closest('[data-action="close-drawer"]')) {
      closeButton.click();
      return;
    }

    const dot = event.target.closest('[data-swipe-index]');
    const swipe = dot && dot.closest('.SidebarMenu__Swipe');
    const track = swipe && swipe.querySelector('[data-swipe-track]');

    if (dot && track) {
      const cards = track.querySelectorAll('.SidebarMenu__SwipeCard');
      const index = Number(dot.getAttribute('data-swipe-index'));
      const nextCard = cards[index];

      if (!nextCard) {
        return;
      }

      track.scrollTo({
        left: nextCard.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, true);

  for (const track of swipeTracks) {
    track.addEventListener('scroll', () => {
      syncSwipeDots(track);
    }, { passive: true });
  }

  window.addEventListener('popstate', () => {
    if (!menuEntry) {
      return;
    }

    menuEntry = false;

    if (leaveHref) {
      const href = leaveHref;
      leaveHref = '';
      window.location.assign(href);
      return;
    }

    if (menu.getAttribute('aria-hidden') === 'false' && menu.classList.contains('is-drilled')) {
      showPanel('root');
    }
  });

  const observer = new MutationObserver(() => {
    if (menu.getAttribute('aria-hidden') === 'true') {
      if (menuEntry) {
        history.back();
      }

      showPanel('root', '', true);
      return;
    }

    unveilSwipeImages();

    for (const track of swipeTracks) {
      syncSwipeDots(track);
    }
  });

  observer.observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
})();



